import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/shared/lib/i18n';
import App from '@/app/App';
import '@/app/styles/index.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
